import { CoreIcon } from '../core-icon';
import appAppstoreSVG from '../../assets/logos/app-appstore.svg';
import type { IconProps } from '../core-icon';

export const AppAppstoreIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={appAppstoreSVG} {...props} />;
};
